import { html, LitElement, PropertyValues, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import '../Ripple/Ripple';

import styles from './Menu.scss?inline';
import { DismissController } from "./controllers/DismissControler";
import { SurfacePositionController } from "./controllers/SurfacePositionController";

@customElement('app-menu')
export class Menu extends LitElement {
    static styles = [unsafeCSS(styles)];
    @property({ type: Boolean, reflect: true }) k_open = false;
    @property({ attribute: false }) anchorElement: HTMLElement | null = null;

    private positionController = new SurfacePositionController(
        this,
        () => ({
            anchor: () => this.anchorElement,
            surface: () => this,
        })
    );

    //@ts-ignore // FIXME REVISAR typecheck
    private dismissController = new DismissController(
        this,
        {
            surface: () => this,
            anchor: () => this.anchorElement,
            onDismiss: () => this.close(),
        }
    )

    render() {
        return html`
            <div class='scroll-wrapper'>
                <slot></slot>
            </div>
        `
    }

    show() {
        this.k_open = true;
    }

    close() {
        if (this.k_open) {
            this.k_open = false;
        }
    }

    toggle() {
        this.k_open = !this.k_open
    }

    protected override updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);

        if ((changedProperties.has('k_open') && this.k_open)) {

            requestAnimationFrame(() => {
                this.positionController.reposition();
            });
        }
    }
}